export default __webpack_public_path__ + "static/media/mg-icon.25b105aa.svg";